<template>
    <div class="scheduled-card">
        <div class="item-bar" :style="{ 'background-color': scheduledData.colorCode }"></div>
        <div class="content">
            <header>
                <h3 :title="(scheduledData ||{}).name">
                    <router-link :to="{name:'PlanningDetails', params:{ planningDate: scheduledData.date}}" tag="a">
                        {{(scheduledData ||{}).name}}
                    </router-link>
                </h3>
            </header>
            <div class="status" :title="statusLabel.label">
                <i :class="statusLabel.icon"></i>
                <span>{{statusLabel.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScheduledCard",
        props: {
            date: { type: Object },
            scheduledData: { type: Object }
        },
        computed: {
            statusLabel() {
                var defaultStatus = {
                    label: "unknown", icon: ""
                };

                if (!this.scheduledData) return defaultStatus;

                // console.log('sheduled data :', this.scheduledData);

                switch (this.scheduledData.status) {
                    case 0: return {
                        label: "Pooled", icon: "far fa-clock"
                    };
                    case 1: return {
                        label: "Reserved", icon: "fas fa-hourglass-start"
                    };
                    case 2: return {
                        label: "Initializing", icon: "fas fa-hourglass-start"
                    };
                    case 3: return {
                        label: "Generating", icon: "fas fa-hourglass-start"
                    };
                    case 4: return {
                        label: "Saving", icon: "fas fa-hourglass-start"
                    };
                    case 5: return {
                        label: "Ended", icon: "fas fa-check"
                    };
                    case 6: return {
                        label: "Error", icon: "fas fa-exclamation-circle"
                    };
                }
                return defaultStatus;
            }
        }
    }
</script>

<style lang="scss">
    .scheduled-card {
        width: calc(100% - 20px);
        height: calc(100% - 35px);
        min-height: 60px;
        padding: 5px;
        position: relative;
        background: rgba(255,255,255,0.95);
        margin: 0 10px;
        border-radius: 5px;

        .item-bar {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 3px;
            border-radius: 5px;
        }

        header {
            color: #575962;

            h3 {
                font-size: 12px;
                font-weight: 800;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 0 5px;
            }
        }

        .content .status {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: 5px;
            left: 13px;

            i {
                margin-top: -2px;
                font-size: 14px;
            }

            span {
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 0 0 0 3px;
            }
        }
    }
</style>
